import type { ElementType } from 'react';

import { IconBackgroundRemove } from '@picsart/design-system/foundation/icons/IconBackgroundRemove';
import { IconObjectResize } from '@picsart/design-system/foundation/icons/IconObjectResize';
import { IconAITools } from '@picsart/design-system/foundation/icons/IconAITools';
import { IconCrop } from '@picsart/design-system/foundation/icons/IconCrop';
import { IconEffects } from '@picsart/design-system/foundation/icons/IconEffects';
import { IconAdjust } from '@picsart/design-system/foundation/icons/IconAdjust';
import { IconElements } from '@picsart/design-system/foundation/icons/IconElements';
import { IconGenAI } from '@picsart/design-system/foundation/icons/IconGenAI';

import { BATCH_ACTIONS } from 'pages/Batch/configs';
import type { IPreset } from 'services/presets/types';

interface IBatchActionDisplay {
  label: string;
  icon: ElementType;
}

export const BATCH_ACTION_DISPLAY: Record<BATCH_ACTIONS, IBatchActionDisplay> = {
  [BATCH_ACTIONS.removeBackground]: { label: 'Remove BG', icon: IconBackgroundRemove },
  [BATCH_ACTIONS.applyBackground]: { label: 'Background', icon: IconBackgroundRemove },
  [BATCH_ACTIONS.generateAIBackground]: { label: 'AI Background', icon: IconAITools },
  [BATCH_ACTIONS.applyEnhance]: { label: 'AI Enhance', icon: IconAITools },
  [BATCH_ACTIONS.aiEnhance]: { label: 'AI Enhance', icon: IconAITools },
  [BATCH_ACTIONS.applyCrop]: { label: 'Crop', icon: IconCrop },
  [BATCH_ACTIONS.watermark]: { label: 'Elements', icon: IconElements },
  [BATCH_ACTIONS.resize]: { label: 'Resize', icon: IconObjectResize },
  [BATCH_ACTIONS.wfx]: { label: 'Effects', icon: IconEffects },
  [BATCH_ACTIONS.applyWfx]: { label: 'Effects', icon: IconEffects },
  [BATCH_ACTIONS.adjust]: { label: 'Adjust', icon: IconAdjust },
  [BATCH_ACTIONS.applyAdjust]: { label: 'Adjust', icon: IconAdjust },
  [BATCH_ACTIONS.composedEnhance]: { label: 'Effects', icon: IconEffects },
  [BATCH_ACTIONS.aiEdit]: { label: 'AI Editor', icon: IconGenAI },
};

export interface IPresetShelf {
  id: string;
  title: string;
  userManaged: boolean;
  presets: IPreset[];
}

export const USER_SHELF_ID = 'my_presets';
export const USER_SHELF_TITLE = 'My presets';

export const SHELF_ITEM_HEIGHT_DESKTOP = 180;
export const SHELF_ITEM_HEIGHT_MOBILE = 140;
export const SHELF_MAX_ITEMS = 10;
